module.exports = __webpack_public_path__ + "img/34200.9ceaa6e1.jpg";